import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import { useDisplayUserInfo } from '@/dashboard/hooks/useDisplayUserInfo';
import { CheckCircleIcon } from '@heroicons/react/outline';
import { formatCommonDateStr } from '@jove-frontend/uikit';
import { Box, Button, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';

type ExtendPolicySuccessViewProps = CustomDialogProps & {
  submitInfo: {
    endDate: Dayjs;
  };
};

const ExtendPolicySuccessView = (props: ExtendPolicySuccessViewProps) => {
  const {
    close,
    submitInfo: { endDate },
  } = props;
  const { displayUserInfo } = useDisplayUserInfo();

  /**
   * methods
   */
  // click ok
  const closeAction = () => {
    if (close) close();
  };

  return (
    <Box className="flex flex-col items-center">
      <Box className="bg-brand-secondary/20 text-brand-secondary rounded-full p-2">
        <CheckCircleIcon className="h-7 w-7" />
      </Box>
      <Typography className="text-black-secondary mt-4 text-center font-black" variant="h5">
        Your business insurance has been extended successfully.
      </Typography>
      <Typography className="text-black-secondary mt-3 text-center" variant="body2">
        Your new policy will be active till
        <Typography className="mx-1 inline-block font-bold" variant="subtitle2">
          {formatCommonDateStr(endDate)}
        </Typography>
      </Typography>
      <Typography className="text-black-secondary mt-3 text-center" variant="body2">
        We’ve sent you an email at
        <Typography className="mx-1 inline-block font-bold" variant="subtitle2">
          {displayUserInfo?.email}
        </Typography>
        with your new policy documents.
      </Typography>
      <Button className="mt-10 h-12 w-[206px] rounded-full text-lg font-bold" color="primary" variant="contained" onClick={closeAction}>
        Back to My policies
      </Button>
    </Box>
  );
};

export default ExtendPolicySuccessView;
